import { css } from '@emotion/core';

import { layers } from '@/styles';

export const root = css`
  position: relative;

  z-index: ${layers.dialog()};
`;

export const hiddenField = css`
  display: none;
`;

export const formStyle = css`
  display: grid;
  grid-gap: 6px;
  grid-auto-flow: column;
  align-items: center;

  /* NOTE: The first children of the Select is a styled-component that applies margin */
  & > :first-child {
    flex: 1;
    margin-top: 0;
    min-width: 180px;
  }
`;
